export type NewsKind = 'RELEASED' | 'PATCHED' | 'UPDATED' | 'RENAMED' | 'ANNOUNCEMENT';

export interface INews {
  id: string;
  title: string;
  description: string;
  kind: NewsKind;
  categoryTag: string | null;
  eventDate: string;
  archived: boolean;
  archivedAt: string | null;
  createdAt: string;
  createdBy: string | null;
  updatedAt: string;
  updatedBy: string | null;
}

export type INewsCreate = Pick<
  INews,
  'title' | 'description' | 'kind' | 'categoryTag' | 'eventDate'
>;

export interface INewsKindMeta {
  verb: string;
  iconName: string;
}

export const NEWS_KIND_META: Record<NewsKind, INewsKindMeta> = {
  RELEASED: { verb: 'RELEASED', iconName: 'CheckCircleIcon' },
  PATCHED: { verb: 'PATCHED', iconName: 'WrenchIcon' },
  UPDATED: { verb: 'UPDATED', iconName: 'ArrowPathIcon' },
  RENAMED: { verb: 'RENAMED', iconName: 'TagIcon' },
  ANNOUNCEMENT: { verb: 'ANNOUNCED', iconName: 'MegaphoneIcon' },
};
